import { getRibbonMailboxInfo } from './getRibbonMailboxInfo';
import { type MenuItemType } from 'owa-filterable-menu/lib/components/MenuItemType';
import ClockAlarm from 'owa-fluent-icons-svg/lib/icons/ClockAlarmRegular';
import AddSquareRegular from 'owa-fluent-icons-svg/lib/icons/AddSquareRegular';
import AccessibilityCheckmark from 'owa-fluent-icons-svg/lib/icons/AccessibilityCheckmarkRegular';
import AppFolderRegular from 'owa-fluent-icons-svg/lib/icons/AppFolderRegular';
import AppsAddIn from 'owa-fluent-icons-svg/lib/icons/AppsAddInRegular';
import ArrowResetRegular from 'owa-fluent-icons-svg/lib/icons/ArrowResetRegular';
import ArrowClockwiseRegular from 'owa-fluent-icons-svg/lib/icons/ArrowClockwiseRegular';
import ArrowRepeatAllOff from 'owa-fluent-icons-svg/lib/icons/ArrowRepeatAllOffRegular';
import ArrowRepeatAll from 'owa-fluent-icons-svg/lib/icons/ArrowRepeatAllRegular';
import AttachRegular from 'owa-fluent-icons-svg/lib/icons/AttachRegular';
import Undo from 'owa-fluent-icons-svg/lib/icons/ArrowUndoRegular';
import Broom from 'owa-fluent-icons-svg/lib/icons/BroomRegular';
import CalendarRegular from 'owa-fluent-icons-svg/lib/icons/CalendarRegular';
import CalendarMailRegular from 'owa-fluent-icons-svg/lib/icons/CalendarMailRegular';
import ChatRegular from 'owa-fluent-icons-svg/lib/icons/ChatRegular';
import Classification from 'owa-fluent-icons-svg/lib/icons/ClassificationRegular';
import ClipboardDataBar from 'owa-fluent-icons-svg/lib/icons/ClipboardDataBarRegular';
import ClipboardPaste from 'owa-fluent-icons-svg/lib/icons/ClipboardPasteRegular';
import CloudArrowDown from 'owa-fluent-icons-svg/lib/icons/CloudArrowDownRegular';
import CloudOff from 'owa-fluent-icons-svg/lib/icons/CloudOffRegular';
import Color from 'owa-fluent-icons-svg/lib/icons/ColorRegular';
import DocumentRegular from 'owa-fluent-icons-svg/lib/icons/DocumentRegular';
import Delete from 'owa-fluent-icons-svg/lib/icons/DeleteRegular';
import FlagRegular from 'owa-fluent-icons-svg/lib/icons/FlagRegular';
import FolderSwap from 'owa-fluent-icons-svg/lib/icons/FolderSwapRegular';
import ImportantRegular from 'owa-fluent-icons-svg/lib/icons/ImportantRegular';
import ToggleLeftRegular from 'owa-fluent-icons-svg/lib/icons/ToggleLeftRegular';
import MailListRegular from 'owa-fluent-icons-svg/lib/icons/MailListRegular';
import MailMultipleRegular from 'owa-fluent-icons-svg/lib/icons/MailMultipleRegular';
import MailRegular from 'owa-fluent-icons-svg/lib/icons/MailRegular';
import MailUnread from 'owa-fluent-icons-svg/lib/icons/MailUnreadRegular';
import MentionRegular from 'owa-fluent-icons-svg/lib/icons/MentionRegular';
import ComposeRegular from 'owa-fluent-icons-svg/lib/icons/ComposeRegular';
import MailSettings from 'owa-fluent-icons-svg/lib/icons/MailSettingsRegular';
import Note from 'owa-fluent-icons-svg/lib/icons/NoteRegular';
import PaintBrush from 'owa-fluent-icons-svg/lib/icons/PaintBrushRegular';
import PanelLeftFilled from 'owa-fluent-icons-svg/lib/icons/PanelLeftFilled';
import PanelLeftFocusRightFilled from 'owa-fluent-icons-svg/lib/icons/PanelLeftFocusRightFilled';
import PanelLeftRegular from 'owa-fluent-icons-svg/lib/icons/PanelLeftRegular';
import PeopleCommunity from 'owa-fluent-icons-svg/lib/icons/PeopleCommunityRegular';
import PersonRegular from 'owa-fluent-icons-svg/lib/icons/PersonRegular';
import SearchSettingsRegular from 'owa-fluent-icons-svg/lib/icons/SearchSettingsRegular';
import Send from 'owa-fluent-icons-svg/lib/icons/SendRegular';
import Settings from 'owa-fluent-icons-svg/lib/icons/SettingsRegular';
import TextDensityRegular from 'owa-fluent-icons-svg/lib/icons/TextDensityRegular';
import ZoomInRegular from 'owa-fluent-icons-svg/lib/icons/ZoomInRegular';
import TextCollapseRegular from 'owa-fluent-icons-svg/lib/icons/TextCollapseRegular';
import TextExpandRegular from 'owa-fluent-icons-svg/lib/icons/TextExpandRegular';
import WindowFilled from 'owa-fluent-icons-svg/lib/icons/WindowFilled';
import WeatherSunnyRegular from 'owa-fluent-icons-svg/lib/icons/WeatherSunnyRegular';
import WeatherMoonRegular from 'owa-fluent-icons-svg/lib/icons/WeatherMoonRegular';
import DismissSquareRegular from 'owa-fluent-icons-svg/lib/icons/DismissSquareRegular';
import GlobeRegular from 'owa-fluent-icons-svg/lib/icons/GlobeRegular';
import { CalendarTodoRegular } from 'owa-ribbon-brand-icons/lib/icons/CalendarTodoRegular';
import loc from 'owa-localize';
import { accCheckerMenuItemText as AccessibilityCheckerStrings_accCheckerMenuItemText } from 'owa-locstrings/lib/strings/acccheckermenuitemtext.locstring.json';
import { changeNoteColorMenuText as ChangeNoteColorStrings_changeNoteColorMenuText } from 'owa-locstrings/lib/strings/changenotecolormenutext.locstring.json';
import { switchToHTMLMenuItem as CommandBarStrings_switchToHTMLMenuItem } from 'owa-locstrings/lib/strings/commandBarStrings.locstring.json';
import { composeDiscardButton as DiscardStrings_composeDiscardButton } from 'owa-locstrings/lib/strings/composediscardbutton.locstring.json';
import { composeSendButton as ComposeStrings_composeSendButton } from 'owa-locstrings/lib/strings/composesendbutton.locstring.json';
import { deleteItem as DeleteStrings_deleteItem } from 'owa-locstrings/lib/strings/deleteitem.locstring.json';
import { restoreAll } from 'owa-locstrings/lib/strings/restoreall.locstring.json';
import { restoreItem } from 'owa-locstrings/lib/strings/restoreitem.locstring.json';
import {
    browseGroups_Button as Strings_browseGroups_Button,
    cancelSync_Button as Strings_cancelSync_Button,
    collapseConversation_Button as Strings_collapseConversation_Button,
    conversations_Button as Strings_conversations_Button,
    density_Button as Strings_density_Button,
    downloadHeaders_Button as Strings_downloadHeaders_Button,
    expandConversation_Button as Strings_expandConversation_Button,
    folder_Button as Strings_folder_Button,
    formatPainter_Button as Strings_formatPainter_Button,
    getMessageExtensions_Button as Strings_getMessageExtensions_Button,
    layout_Button as Strings_layout_Button,
    messagePreview_Button as Strings_messagePreview_Button,
    messages_Button as Strings_messages_Button,
    newEMailMessage_Button as Strings_newEMailMessage_Button,
    newMessage_Button as Strings_newMessage_Button,
    newMessage_Button_MLR as Strings_newMessage_Button_MLR,
    newNote_HeroButton as Strings_newNote_HeroButton,
    newPostHero_Button as Strings_newPostHero_Button,
    newPost_Button as Strings_newPost_Button,
    paste_FlyoutButton as Strings_paste_FlyoutButton,
    remindersWindow_Button as Strings_remindersWindow_Button,
    ribbonCustomizer_Button as Strings_ribbonCustomizer_Button,
    ribbonMode_Button as Strings_ribbonMode_Button,
    sendAll_Button as Strings_sendAll_Button,
    sendReceiveAllFolders_Button as Strings_sendReceiveAllFolders_Button,
    sendReceiveGroups_Button as Strings_sendReceiveGroups_Button,
    sensitivity_FlyoutButton as Strings_sensitivity_FlyoutButton,
    showSyncProgress_Button as Strings_showSyncProgress_Button,
    sweepEmail_Button as Strings_sweepEmail_Button,
    syncMailbox_Button as Strings_syncMailbox_Button,
    undo_Button as Strings_undo_Button,
    updateFolder_Button as Strings_updateFolder_Button,
    viewGroupsPanel_Button as Strings_viewGroupsPanel_Button,
    viewGroupsPanel_Button_MLR as Strings_viewGroupsPanel_Button_MLR,
    viewSettings_Button as Strings_viewSettings_Button,
    workOffline_Button as Strings_workOffline_Button,
    zoom_Button as Strings_zoom_Button,
} from 'owa-locstrings/lib/strings/ribbon_mail_buttons_and_tabs.locstring.json';
import {
    newMessage_SplitButton as SplitButtonStrings_newMessage_SplitButton,
    viewGroups_SplitButton as SplitButtonStrings_viewGroups_SplitButton,
} from './ribbon_mail_split_buttons.locstring.json';
import {
    allApps_Button as RibbonMailStrings_allApps_Button,
    customSortButton as RibbonMailStrings_customSortButton,
    favoriteSettingsButton as RibbonMailStrings_favoriteSettingsButton,
    folderSettingsButton as RibbonMailStrings_folderSettingsButton,
    lightRPOffButton as RibbonMailStrings_lightRPOffButton,
    lightRPOnButton as RibbonMailStrings_lightRPOnButton,
    messageListOrganizationButton as RibbonMailStrings_messageListOrganizationButton,
    myDayButton as RibbonMailStrings_myDayButton,
    newEmail_Button as RibbonMailStrings_newEmail_Button,
    newItems_Button as RibbonMailStrings_newItems_Button,
    toDoBarButton as RibbonMailStrings_toDoBarButton,
    useTighterSpacingButton as RibbonMailStrings_useTighterSpacingButton,
    readingPaneMessageViewButton as RibbonMailStrings_readingPaneMessageViewButton,
    unifiedInboxSettingsButton as RibbonMailStrings_unifiedInboxSettingsButton,
} from './ribbon_mail_strings.locstring.json';
import { clpLabelDropDownLearnMoreButtonText as SensitivityStrings_clpLabelDropDownLearnMoreButtonText } from 'owa-locstrings/lib/strings/sensitivitymenutext.locstring.json';
import { showFrom as ShowFromStrings_showFrom } from 'owa-locstrings/lib/strings/showfrom.locstring.json';
import { showMessageOptions as MessageSettingsStrings_showMessageOptions } from 'owa-locstrings/lib/strings/showmessageoptions.locstring.json';
import { switchToPlainTextMenuItem as SwitchToPlainTextMenuItemStrings_switchToPlainTextMenuItem } from 'owa-locstrings/lib/strings/switchtoplaintextmenuitem.locstring.json';
import { addApps as MoreAppsStrings_addApps } from 'owa-locstrings/lib/strings/moreapps.locstring.json';
import { viewEmailFromNoteLabel as ViewEmailFromNoteStrings_viewEmailFromNoteLabel } from 'owa-locstrings/lib/strings/viewemailfromnotelabel.locstring.json';
import { getMailMenuItemShouldShow } from 'owa-mail-filterable-menu-behavior';
import { isPublicFolderSelected } from 'owa-publicfolder-utils';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';
import { optionTitle_readingPane as ReadingPaneStrings_optionTitle_readingPane } from 'owa-reading-pane-option/lib/ReadingPaneOption.locstring.json';
import { type ActionControlId } from 'owa-ribbon-ids/lib/actionControlId';
import { type MailRibbonControlId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type {
    ComposeRibbonControlDefProps,
    RibbonControlDefinitionProps,
    ReadOnlyRibbonControlDefProps,
} from './RibbonControlDefinitionProps';
import type { RibbonControlId } from 'owa-ribbon-ids';
import { getHoverTooltip } from './HoverTooltips/hoverTooltipConfig';
import type { ControlInfo } from './controlInfo';
import { isAllItemPartsExpanded } from 'owa-mail-reading-pane-store-conversation/lib/utils/isAllItemPartsExpanded';
import getIsLightRPOn from 'owa-light-reading-pane-store/lib/selectors/getIsLightRPOn';
import { isSingleLineRibbon } from 'owa-command-ribbon-store/lib/selectors/isSingleLineRibbon';
import { getAddIns_Button } from 'owa-locstrings/lib/strings/get_addins_button.locstring.json';
import {
    searchRibbon_UnreadRefiner_Label,
    searchRibbon_ToMeRefiner_Label,
    searchRibbon_MentionedRefiner_Label,
    searchRibbon_FlaggedRefiner_Label,
    searchRibbon_HighImportanceRefiner_Label,
    searchRibbon_DatePickerRefiner_Label,
    searchRibbon_AttachmentRefiner_Label,
    searchRibbon_IncludeChannels_Label,
    searchRibbon_SearchEntityAll_Label,
    searchRibbon_SearchEntityMail_Label,
    searchRibbon_SearchEntityChats_Label,
    searchRibbon_SearchEntityFiles_Label,
    searchRibbon_SearchEntityPeople_Label,
    searchRibbon_CloseSearch_Label,
    searchRibbon_AdvancedSearch_Label,
    searchRibbon_HighlightToggle_Label,
} from './ribbon_mail_search_tab.locstring.json';

/**
 * Retrieves the display information pertaining to a given mail ribbon
 * control
 * @param controlId for which to retrieve the display information for
 * @param props the definition props
 * @returns display information for passed in control
 */
export function getControlInfo(
    controlId: RibbonControlId,
    props: RibbonControlDefinitionProps
): ControlInfo {
    const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);
    switch (controlId) {
        //home tab controls
        case 587: {
            const controlName: string = loc(Strings_newEMailMessage_Button);

            return {
                iconName: ComposeRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 586: {
            const controlName = loc(RibbonMailStrings_newItems_Button);

            return {
                iconName: CalendarMailRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 588: {
            const isNote: boolean = getMailMenuItemShouldShow(57, mailboxInfo);
            const ariaText: string = loc(SplitButtonStrings_newMessage_SplitButton);

            if (isNote) {
                return {
                    iconName: Note,
                    text: loc(Strings_newNote_HeroButton),
                    ariaText,
                };
            }

            const isPublicFolder = isPublicFolderSelected();

            const controlName = isPublicFolder
                ? loc(Strings_newPostHero_Button)
                : loc(Strings_newMessage_Button);

            const controlText = !isPublicFolder
                ? isWin32StylingEnabled()
                    ? loc(RibbonMailStrings_newEmail_Button)
                    : !isSingleLineRibbon()
                    ? loc(Strings_newMessage_Button_MLR)
                    : controlName
                : controlName;

            return {
                iconName: ComposeRegular,
                text: controlText,
                ariaText,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 656: {
            const controlName: string = loc(Strings_newPost_Button);

            return {
                iconName: MailRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 572: {
            const controlName: string = loc(Strings_sweepEmail_Button);

            return {
                iconName: Broom,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 508: {
            const controlName: string = loc(Strings_browseGroups_Button);

            return {
                iconName: PeopleCommunity,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 663: {
            const controlName = loc(Strings_viewGroupsPanel_Button);
            const controlSplitButtonAriaText = loc(SplitButtonStrings_viewGroups_SplitButton);

            const controlText = isSingleLineRibbon()
                ? controlName
                : loc(Strings_viewGroupsPanel_Button_MLR);

            return {
                iconName: PeopleCommunity,
                text: controlText,
                ariaText: controlSplitButtonAriaText,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 580: {
            const controlName: string = loc(Strings_undo_Button);

            return {
                iconName: Undo,
                text: controlName,

                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 529: {
            const controlName: string = loc(getAddIns_Button);

            return {
                iconName: AppsAddIn,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 7016: {
            const controlName: string = loc(
                isWin32StylingEnabled()
                    ? RibbonMailStrings_allApps_Button
                    : Strings_getMessageExtensions_Button
            );

            return {
                iconName: AppFolderRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 683: {
            const controlName = loc(restoreItem);
            return {
                iconName: ArrowResetRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 684: {
            const controlName = loc(restoreAll);
            return {
                iconName: ArrowResetRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        // view tab controls
        case 643: {
            const controlName: string = loc(Strings_viewSettings_Button);

            return {
                iconName: Settings,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 644: {
            const controlName: string = loc(Strings_conversations_Button);

            return {
                iconName: MailMultipleRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 645: {
            const controlName: string = loc(Strings_messagePreview_Button);

            return {
                iconName: MailListRegular,
                text: controlName,

                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 646: {
            const controlName: string = loc(Strings_layout_Button);

            return {
                iconName: PanelLeftRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }
        case 647: {
            const controlName: string = loc(Strings_folder_Button);

            return {
                iconName: PanelLeftFilled,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }
        case 648: {
            const controlName: string = loc(ReadingPaneStrings_optionTitle_readingPane);

            return {
                iconName: PanelLeftFocusRightFilled,
                text: controlName,

                tooltip: getHoverTooltip(controlId, controlName),
            };
        }
        case 706: {
            const controlName: string = loc(
                isWin32StylingEnabled()
                    ? RibbonMailStrings_toDoBarButton
                    : RibbonMailStrings_myDayButton
            );
            return {
                iconName: CalendarTodoRegular,
                text: controlName,

                tooltip: getHoverTooltip(controlId, controlName),
            };
        }
        case 649: {
            const controlName: string = loc(
                isWin32StylingEnabled()
                    ? RibbonMailStrings_useTighterSpacingButton
                    : Strings_density_Button
            );
            return {
                iconName: TextDensityRegular,
                text: controlName,

                tooltip: getHoverTooltip(controlId, controlName),
            };
        }
        case 654: {
            const controlName: string = loc(Strings_messages_Button);
            return {
                iconName: MailRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 690: {
            const controlName: string = loc(Strings_remindersWindow_Button);
            return {
                iconName: ClockAlarm,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }
        //message tab controls
        case 546:
            return {
                iconName: ClipboardPaste,
                text: loc(Strings_paste_FlyoutButton),
            };
        case 569:
            return {
                iconName: '', // Icon "on order" from fluent
                text: loc(ShowFromStrings_showFrom),
            };

        case 528:
            return {
                iconName: PaintBrush,
                text: loc(Strings_formatPainter_Button),
            };

        case 564: {
            const controlName: string = loc(Strings_sensitivity_FlyoutButton);

            return {
                iconName: Classification,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 565: {
            const controlName: string = loc(SensitivityStrings_clpLabelDropDownLearnMoreButtonText);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 570:
            return {
                iconName: MailSettings,
                text: loc(MessageSettingsStrings_showMessageOptions),
            };
        case 573:
            const viewState = (props as ComposeRibbonControlDefProps)?.composeViewState;
            const buttonText =
                viewState && viewState.bodyType != 'HTML'
                    ? CommandBarStrings_switchToHTMLMenuItem
                    : SwitchToPlainTextMenuItemStrings_switchToPlainTextMenuItem;
            return {
                iconName: '', // Currently no icon, by design
                text: loc(buttonText),
            };
        case 510:
            return {
                iconName: AccessibilityCheckmark,
                text: loc(AccessibilityCheckerStrings_accCheckerMenuItemText),
            };

        //send receive tab controls
        case 562:
            return {
                iconName: ArrowRepeatAll,
                text: loc(Strings_sendReceiveAllFolders_Button),
            };
        case 561:
            return {
                iconName: Send,
                text: loc(Strings_sendAll_Button),
            };
        case 582:
            return {
                iconName: FolderSwap,
                text: loc(Strings_updateFolder_Button),
            };
        case 563:
            return {
                iconName: FolderSwap,
                text: loc(Strings_sendReceiveGroups_Button),
            };
        case 575:
            return {
                iconName: ClipboardDataBar,
                text: loc(Strings_showSyncProgress_Button),
            };
        case 574:
            return {
                iconName: ArrowRepeatAllOff,
                text: loc(Strings_cancelSync_Button),
            };
        case 544:
            return {
                iconName: CloudOff,
                text: loc(Strings_workOffline_Button),
            };
        case 521:
            return {
                iconName: CloudArrowDown,
                text: loc(Strings_downloadHeaders_Button),
            };

        //toolbar message tab
        case 594: {
            const controlName: string = loc(ComposeStrings_composeSendButton);

            return {
                iconName: Send,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 593: {
            const controlName: string = loc(DiscardStrings_composeDiscardButton);

            return {
                iconName: Delete,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 558: {
            const controlName: string = loc(Strings_ribbonCustomizer_Button);

            return {
                iconName: '',
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        //insert tab controls
        case 640: {
            const controlName: string = loc(DeleteStrings_deleteItem);
            return {
                iconName: Delete,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 641: {
            const controlName: string = loc(ChangeNoteColorStrings_changeNoteColorMenuText);
            return {
                iconName: Color,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 642: {
            const controlName: string = loc(ViewEmailFromNoteStrings_viewEmailFromNoteLabel);
            return {
                iconName: MailRegular,
                text: controlName,

                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 7022: {
            const controlName: string = loc(
                isWin32StylingEnabled() ? RibbonMailStrings_allApps_Button : MoreAppsStrings_addApps
            );
            return {
                iconName: AddSquareRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 687: {
            const conversationId = (props as ReadOnlyRibbonControlDefProps)?.itemId;
            const allItemsExpanded = isAllItemPartsExpanded(conversationId?.Id ?? '');
            const controlName: string = allItemsExpanded
                ? loc(Strings_collapseConversation_Button)
                : loc(Strings_expandConversation_Button);

            return {
                iconName: allItemsExpanded ? TextCollapseRegular : TextExpandRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 688: {
            const controlName: string = loc(Strings_zoom_Button);

            return {
                iconName: ZoomInRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 720: {
            const isLightRPOn = getIsLightRPOn();
            const controlName: string = isLightRPOn
                ? loc(RibbonMailStrings_lightRPOffButton)
                : loc(RibbonMailStrings_lightRPOnButton);

            return {
                iconName: isLightRPOn ? WeatherMoonRegular : WeatherSunnyRegular,
                text: controlName,

                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 691: {
            const controlName: string = loc(Strings_ribbonMode_Button);

            return {
                iconName: WindowFilled,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 701: {
            const controlName: string = loc(Strings_syncMailbox_Button);
            return {
                iconName: ArrowClockwiseRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 735: {
            const controlName: string = loc(RibbonMailStrings_unifiedInboxSettingsButton);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 714: {
            const controlName: string = loc(RibbonMailStrings_folderSettingsButton);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 715: {
            const controlName: string = loc(RibbonMailStrings_favoriteSettingsButton);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 716: {
            const controlName: string = loc(RibbonMailStrings_customSortButton);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 721: {
            const controlName: string = loc(RibbonMailStrings_messageListOrganizationButton);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 722: {
            const controlName: string = loc(RibbonMailStrings_readingPaneMessageViewButton);

            return {
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }
        // Search Tools tab controls
        case 739: {
            const controlName: string = loc(searchRibbon_AdvancedSearch_Label);

            return {
                iconName: SearchSettingsRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 740: {
            const controlName: string = loc(searchRibbon_CloseSearch_Label);

            return {
                iconName: DismissSquareRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 766: {
            const controlName: string = loc(searchRibbon_HighlightToggle_Label);

            return {
                iconName: ToggleLeftRegular,
                text: controlName,
                tooltip: getHoverTooltip(controlId, controlName),
            };
        }

        case 749: {
            return {
                iconName: PeopleCommunity,
                text: loc(searchRibbon_IncludeChannels_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_IncludeChannels_Label)),
            };
        }

        // Search refiner controls
        case 741: {
            return {
                iconName: AttachRegular,
                text: loc(searchRibbon_AttachmentRefiner_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_AttachmentRefiner_Label)),
            };
        }

        case 742: {
            return {
                iconName: MailUnread,
                text: loc(searchRibbon_UnreadRefiner_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_UnreadRefiner_Label)),
            };
        }

        case 743: {
            return {
                iconName: MentionRegular,
                text: loc(searchRibbon_MentionedRefiner_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_MentionedRefiner_Label)),
            };
        }

        case 744: {
            return {
                iconName: MentionRegular,
                text: loc(searchRibbon_MentionedRefiner_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_MentionedRefiner_Label)),
            };
        }

        case 745: {
            return {
                iconName: FlagRegular,
                text: loc(searchRibbon_FlaggedRefiner_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_FlaggedRefiner_Label)),
            };
        }

        case 746: {
            return {
                iconName: ImportantRegular,
                text: loc(searchRibbon_HighImportanceRefiner_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_HighImportanceRefiner_Label)),
            };
        }

        case 747: {
            return {
                iconName: PersonRegular,
                text: loc(searchRibbon_ToMeRefiner_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_ToMeRefiner_Label)),
            };
        }

        case 748: {
            return {
                iconName: CalendarRegular,
                text: loc(searchRibbon_DatePickerRefiner_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_DatePickerRefiner_Label)),
            };
        }

        // Entity filter controls
        case 750: {
            return {
                iconName: MailRegular,
                text: loc(searchRibbon_SearchEntityMail_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_SearchEntityMail_Label)),
            };
        }

        case 751: {
            return {
                iconName: ChatRegular,
                text: loc(searchRibbon_SearchEntityChats_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_SearchEntityChats_Label)),
            };
        }

        case 752: {
            return {
                iconName: DocumentRegular,
                text: loc(searchRibbon_SearchEntityFiles_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_SearchEntityFiles_Label)),
            };
        }

        case 753: {
            return {
                iconName: PersonRegular,
                text: loc(searchRibbon_SearchEntityPeople_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_SearchEntityPeople_Label)),
            };
        }

        case 754: {
            return {
                iconName: GlobeRegular,
                text: loc(searchRibbon_SearchEntityAll_Label),
                tooltip: getHoverTooltip(controlId, loc(searchRibbon_SearchEntityAll_Label)),
            };
        }

        default:
            /* eslint-disable-next-line owa-custom-rules/no-error-dynamic-event-names -- (https://aka.ms/OWALintWiki)
             * Error constructor names can only be a string literals.
             *	> Error constructor names can only be a string literals. Use the diagnosticInfo to add custom data. */
            throw new Error(
                'The ribbon id ' +
                    controlId +
                    ' was not added to the switch case in getControlInfo.ts'
            );
    }
}
